import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";

import { logoutFromHelper } from "api/Helper";
import { pathGenerators, ROUTES } from "utils/routes";

import { logout } from "../redux/auth/AuthSlice";
import { removeuser } from "../redux/user/userSlice";

const PrivateRouteLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const userToken = sessionStorage.getItem("accessToken");
    if (!userToken || userToken === "undefined") {
      setIsLoggedIn(false);
      navigate(pathGenerators.auth.login());
      return;
    }

    const tenant = localStorage.getItem("kinesin-tenant");
    if (!tenant) {
      logoutFromHelper();
      dispatch(logout());
      dispatch(removeuser());
      window.location.href = ROUTES.AUTH.LOGOUT;
      return;
    }

    setIsLoggedIn(true);
  }, [navigate, dispatch]);

  if (!isLoggedIn) {
    return null;
  }

  return <Outlet />;
};

export { PrivateRouteLayout };
